import { DateTime } from 'luxon';

/** "Thu 15 Oct, 17:00" in UK time. */
export function ukDateTime(iso: string) {
  return DateTime.fromISO(iso).setZone('Europe/London').toFormat('ccc d LLL, HH:mm');
}

export function downloadText(text: string, name: string, type = 'text/csv;charset=utf-8') {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const a = document.createElement('a');
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
